import React, { useEffect, useState } from 'react';
import ChangelogDialog from './ChangelogDialog.tsx';
import { shouldShowChangelog, setChangelogSeen } from '@/utils/localStorageManager';

const ChangelogModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Check if we should show the changelog on mount
    if (shouldShowChangelog()) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    // Mark changelog as seen when user closes it
    setChangelogSeen();
    setIsOpen(false);
  };

  return <ChangelogDialog open={isOpen} onClose={handleClose} />;
};

export default ChangelogModal;
